/**
 * GameStyles
 *
 * Renders the global CSS block: CRT overlay effect, keyframe animations,
 * effect glow classes, and hover states.
 *
 * Extracted from App.js lines 703–776.
 * No props. No logic. Just styles.
 */

export default function GameStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap');

      .crt-container::after {
        content: " "; display: block; position: fixed; top: 0; left: 0; bottom: 0; right: 0;
        background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.1) 50%),
                    linear-gradient(90deg, rgba(255, 0, 0, 0.02), rgba(0, 255, 0, 0.01), rgba(0, 0, 255, 0.02));
        z-index: 100; background-size: 100% 3px, 3px 100%; pointer-events: none;
      }

      .crt-container::before {
        content: " "; display: block; position: fixed; top: 0; left: 0; bottom: 0; right: 0;
        background: radial-gradient(circle, rgba(18, 16, 16, 0) 40%, rgba(0, 0, 0, 0.5) 110%);
        z-index: 101; pointer-events: none;
      }

      @keyframes sonarPulse {
        0%   { transform: scale(1);    filter: brightness(1); }
        30%  { transform: scale(1.08); filter: brightness(1.8) saturate(2); }
        100% { transform: scale(1);    filter: brightness(1); }
      }

      @keyframes snagImpact {
        0%  { transform: scale(1); filter: brightness(2); }
        10% { transform: translate(-2px,  1px); }
        20% { transform: translate( 2px, -1px); }
        50% { transform: scale(1); filter: brightness(1); }
      }

      @keyframes shakeShrink {
        0%   { transform: scale(1)   rotate(  0deg); }
        10%  { transform: scale(1.1) rotate(-15deg); }
        15%  { transform: scale(1.1) rotate( 15deg); }
        20%  { transform: scale(1.1) rotate(-15deg); }
        25%  { transform: scale(1.1) rotate( 15deg); }
        30%  { transform: scale(1)   rotate(  0deg); }
        50%  { transform: scale(1.1) rotate(-15deg); }
        55%  { transform: scale(1.1) rotate( 15deg); }
        60%  { transform: scale(1.1) rotate(-15deg); }
        65%  { transform: scale(1.1) rotate( 15deg); }
        100% { transform: scale(0)   rotate(  0deg); }
      }

      @keyframes popGrow {
        0%   { transform: scale(0);   opacity: 0; }
        70%  { transform: scale(1.2); opacity: 1; }
        100% { transform: scale(1);   opacity: 1; }
      }

      @keyframes fadeInSlow {
        from { opacity: 0; transform: translateY(10px); }
        to   { opacity: 1; transform: translateY(0);    }
      }

      @keyframes rainbow-shift {
        0%   { filter: hue-rotate(  0deg) saturate(200%); }
        100% { filter: hue-rotate(360deg) saturate(200%); }
      }

      .anim-shake { animation: shakeShrink 3s    forwards ease-in-out; }
      .anim-grow  { animation: popGrow     0.6s  forwards cubic-bezier(0.175, 0.885, 0.32, 1.275); }
      .anim-fade  { animation: fadeInSlow  0.8s  forwards ease-out; }

      .effect-prismatic { animation: rainbow-shift 3s linear infinite; }

      .glow-default  { text-shadow: 0 0 5px  rgba(255,255,255,0.3); }
      .glow-shiny    { text-shadow: 0 0 8px  #a8c7fa, 0 0 15px #a8c7fa; color: #a8c7fa; }
      .glow-neon     { text-shadow: 0 0 10px #ff00ff, 0 0 20px #00ffff; color: #fff; }
      .glow-ethereal { text-shadow: 0 0 15px #bb86fc, 0 0 30px #bb86fc; color: #e3d5ff; }
      .glow-prismatic {
        background: linear-gradient(to right, #ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff);
        -webkit-background-clip: text;
        color: transparent;
        animation: rainbow 3s linear infinite;
      }
      .glow-golden { text-shadow: 0 0 10px #f1c40f, 0 0 20px #f39c12; color: #f1c40f; }

      .pulse-active { animation: sonarPulse 0.6s ease-out; z-index: 5;  }
      .snag-active  { animation: snagImpact 0.4s ease-out; z-index: 10; }

      .menu-btn:hover { background-color: #30363d !important; transform: translateY(-2px); }
      .play-btn:hover { border-color: #238636 !important; color: #44ff44 !important; }
    `}</style>
  );
}